webpackJsonp([114276838955818,60335399758886],{

/***/ 130:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(271);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(130);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/first-principle-logo.c5f2ef54.png";

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(67);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _NavLink = __webpack_require__(53);
	
	var _NavLink2 = _interopRequireDefault(_NavLink);
	
	var _config = __webpack_require__(21);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _FadeIn = __webpack_require__(29);
	
	var _FadeIn2 = _interopRequireDefault(_FadeIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MailtoLink = function (_React$Component) {
	  _inherits(MailtoLink, _React$Component);
	
	  function MailtoLink(props) {
	    _classCallCheck(this, MailtoLink);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  MailtoLink.prototype.mailto = function mailto(e) {
	    e.preventDefault();
	    window.location.href = 'mailto:' + _config2.default.helloEmail;
	  };
	
	  MailtoLink.prototype.componentDidMount = function componentDidMount() {
	    var el = _reactDom2.default.findDOMNode(this);
	    el.addEventListener("click", this.mailto);
	  };
	
	  MailtoLink.prototype.render = function render() {
	    return _react2.default.createElement(
	      _NavLink2.default,
	      { to: '#' },
	      _config2.default.helloEmail
	    );
	  };
	
	  return MailtoLink;
	}(_react2.default.Component);
	
	exports.default = MailtoLink;
	module.exports = exports['default'];

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  @media ', ' {\n    display: none;\n  }\n'], ['\n  @media ', ' {\n    display: none;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  z-index: 4000;\n  display: ', '\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  z-index: 4000;\n  display: ', '\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  line-height: 1;\n  position: fixed;\n  top: ', ';\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  background-color: ', '\n  padding: ', ';\n  overflow: scroll;\n'], ['\n  line-height: 1;\n  position: fixed;\n  top: ', ';\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  background-color: ', '\n  padding: ', ';\n  overflow: scroll;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  line-height: 1;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  background-color: ', '\n  padding: ', ';\n  margin: 0;\n  z-index: 6000;\n'], ['\n  line-height: 1;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  background-color: ', '\n  padding: ', ';\n  margin: 0;\n  z-index: 6000;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  width: 3.364575823rem;\n  margin: 0;\n'], ['\n  width: 3.364575823rem;\n  margin: 0;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  font-size: 0.384522951rem; // 16 px\n  position: absolute;\n  top: 50%;\n  right: ', ';\n  height: ', ';\n  margin-top: ', ';;\n  cursor: pointer;\n'], ['\n  font-size: 0.384522951rem; // 16 px\n  position: absolute;\n  top: 50%;\n  right: ', ';\n  height: ', ';\n  margin-top: ', ';;\n  cursor: pointer;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  margin-top: ', ';\n  text-align: center;\n'], ['\n  margin-top: ', ';\n  text-align: center;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(67);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _gatsbyLink = __webpack_require__(45);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _config = __webpack_require__(21);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _media = __webpack_require__(34);
	
	var _FadeIn = __webpack_require__(29);
	
	var _FadeIn2 = _interopRequireDefault(_FadeIn);
	
	var _NavLink = __webpack_require__(53);
	
	var _NavLink2 = _interopRequireDefault(_NavLink);
	
	var _MailToLink = __webpack_require__(167);
	
	var _MailToLink2 = _interopRequireDefault(_MailToLink);
	
	var _Navbar = __webpack_require__(168);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _firstPrincipleLogo = __webpack_require__(256);
	
	var _firstPrincipleLogo2 = _interopRequireDefault(_firstPrincipleLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var MobileHeaderContainer = _styledComponents2.default.div(_templateObject, _media.device.mobile);
	
	var Header = _styledComponents2.default.header(_templateObject2, function (props) {
	  return props.show ? 'block' : 'none';
	});
	
	var Nav = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.height;
	}, _config2.default.whiteColor, _config2.default.padding);
	
	var HGroup = _styledComponents2.default.hgroup(_templateObject4, _config2.default.whiteColor, _config2.default.padding);
	
	var Logo = _styledComponents2.default.img(_templateObject5);
	
	var NavToggle = _styledComponents2.default.div(_templateObject6, _config2.default.padding, _config2.default.navToggleFontSize + 'px', '-' + _config2.default.navToggleFontSize / 2 + 'px');
	
	var SingleLinkContainer = _styledComponents2.default.div(_templateObject7, _config2.default.padding);
	
	var MobileHeader = function (_React$Component) {
	  _inherits(MobileHeader, _React$Component);
	
	  function MobileHeader(props) {
	    _classCallCheck(this, MobileHeader);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.toggleNav = function () {
	      // const header = ReactDOM.findDOMNode(this.refs.header)
	      if (_this.state.navVisible) {
	        _this.setState({
	          navVisible: false,
	          toggleText: 'Menu'
	        });
	        document.documentElement.style.overflow = '';
	        // header.style.display = 'none'
	      } else {
	        _this.setState({
	          navVisible: true,
	          toggleText: 'Close'
	        });
	        document.documentElement.style.overflow = 'hidden';
	        // header.style.display = 'block'
	      }
	    };
	
	    _this.logoClickHandler = function () {
	      if (_this.state.navVisible) {
	        _this.toggleNav();
	      } else {
	        return false;
	      }
	    };
	
	    _this.componentDidMount = function () {
	      var navToggle = _reactDom2.default.findDOMNode(_this.refs.navToggle);
	      var nav = _reactDom2.default.findDOMNode(_this.refs.nav);
	      var navLinks = nav.getElementsByTagName('a');
	      var hGroup = _reactDom2.default.findDOMNode(_this.refs.hGroup);
	
	      navToggle.addEventListener('click', _this.toggleNav);
	      for (var i = 0; i < navLinks.length - 1; i++) {
	        navLinks[i].addEventListener('click', _this.toggleNav);
	      }
	      _this.setState({ hGroupHeight: hGroup.getBoundingClientRect().height });
	    };
	
	    _this.state = {
	      navVisible: false,
	      toggleText: 'Menu',
	      hGroupHeight: 0
	    };
	    return _this;
	  }
	
	  MobileHeader.prototype.render = function render() {
	    return _react2.default.createElement(
	      MobileHeaderContainer,
	      null,
	      _react2.default.createElement(
	        HGroup,
	        { ref: 'hGroup' },
	        _react2.default.createElement(
	          _FadeIn2.default,
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { onClick: this.logoClickHandler, to: '/' },
	            _react2.default.createElement(Logo, { src: _firstPrincipleLogo2.default, alt: 'First Principle logo' })
	          ),
	          _react2.default.createElement(
	            NavToggle,
	            { ref: 'navToggle' },
	            this.state.toggleText
	          )
	        )
	      ),
	      _react2.default.createElement(
	        Header,
	        { ref: 'header', show: this.state.navVisible },
	        _react2.default.createElement(
	          _FadeIn2.default,
	          null,
	          _react2.default.createElement(
	            Nav,
	            { ref: 'nav' },
	            _react2.default.createElement(_Navbar2.default, { mobileDisplay: 'block', height: this.state.hGroupHeight + 'px' }),
	            _react2.default.createElement(
	              SingleLinkContainer,
	              null,
	              _react2.default.createElement(_MailToLink2.default, null)
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return MobileHeader;
	}(_react2.default.Component);
	
	exports.default = MobileHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  max-width: 40.1041667%;\n  min-width: 180px;\n  margin: 0;\n'], ['\n  max-width: 40.1041667%;\n  min-width: 180px;\n  margin: 0;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: none;\n  @media ', ' {\n    display: block;\n    margin: 2.4994rem auto;\n    padding: 0.25em 0.5em 0;\n    padding-top: 0;\n    position: fixed;\n    top: 0;\n    width: 40%;\n    text-align: center;\n  }\n'], ['\n  display: none;\n  @media ', ' {\n    display: block;\n    margin: 2.4994rem auto;\n    padding: 0.25em 0.5em 0;\n    padding-top: 0;\n    position: fixed;\n    top: 0;\n    width: 40%;\n    text-align: center;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  transform: rotate(90deg);\n  transform-origin: 0 0;\n  line-height: 1;\n  font-size: 0.391076115rem\n  h2 {\n    font-size: 0.391076115rem\n    font-weight: 400;\n  }\n  h2:first-child {\n    margin-right: 58px;\n  }\n  h2:last-child {\n    margin: 0;\n  }\n'], ['\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  transform: rotate(90deg);\n  transform-origin: 0 0;\n  line-height: 1;\n  font-size: 0.391076115rem\n  h2 {\n    font-size: 0.391076115rem\n    font-weight: 400;\n  }\n  h2:first-child {\n    margin-right: 58px;\n  }\n  h2:last-child {\n    margin: 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(67);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _NavLink = __webpack_require__(53);
	
	var _NavLink2 = _interopRequireDefault(_NavLink);
	
	var _gatsbyLink = __webpack_require__(45);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _config = __webpack_require__(21);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _media = __webpack_require__(34);
	
	var _FadeIn = __webpack_require__(29);
	
	var _FadeIn2 = _interopRequireDefault(_FadeIn);
	
	var _MailToLink = __webpack_require__(167);
	
	var _MailToLink2 = _interopRequireDefault(_MailToLink);
	
	var _firstPrincipleLogo = __webpack_require__(256);
	
	var _firstPrincipleLogo2 = _interopRequireDefault(_firstPrincipleLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Logo = _styledComponents2.default.img(_templateObject);
	
	var StyledAside = _styledComponents2.default.div(_templateObject2, _media.device.mobile);
	
	var VerticalLink = _styledComponents2.default.div(_templateObject3);
	
	var VerticalLinksComponent = function (_React$Component) {
	  _inherits(VerticalLinksComponent, _React$Component);
	
	  function VerticalLinksComponent(props) {
	    _classCallCheck(this, VerticalLinksComponent);
	
	    var _this2 = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this2.setupVerticalLinks = function () {
	      var el = _this2.findDOMNode();
	      var _this = _this2;
	      el.style.display = 'block';
	      setTimeout(function () {
	        var coords = el.getBoundingClientRect();
	        var elWidth = coords.width;
	        var elHeight = coords.height;
	        var logoLeft = document.getElementById('logo').getBoundingClientRect().left;
	        el.style.marginBottom = elHeight + 52 + "px";
	        el.style.marginLeft = elWidth + logoLeft + "px";
	      });
	    };
	
	    _this2.componentDidMount = function () {
	      var el = _this2.findDOMNode();
	      var _this = _this2;
	
	      var timeout = false;
	      var delay = 250;
	
	      _this2.setupVerticalLinks();
	      //window.addEventListener('resize', this.setupVerticalLinks)
	      window.addEventListener('resize', function () {
	        el.style.display = 'none';
	        // clear the timeout
	        clearTimeout(timeout);
	        // start timing for event "completion"
	        timeout = setTimeout(_this.setupVerticalLinks, delay);
	      });
	    };
	
	    return _this2;
	  }
	
	  VerticalLinksComponent.prototype.findDOMNode = function findDOMNode() {
	    return _reactDom2.default.findDOMNode(this);
	  };
	
	  VerticalLinksComponent.prototype.render = function render() {
	    return _react2.default.createElement(
	      VerticalLink,
	      null,
	      _react2.default.createElement(
	        _FadeIn2.default,
	        null,
	        _react2.default.createElement(_MailToLink2.default, { email: _config2.default.helloEmail })
	      )
	    );
	  };
	
	  return VerticalLinksComponent;
	}(_react2.default.Component);
	
	var Sidebar = function Sidebar() {
	  return _react2.default.createElement(
	    StyledAside,
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/' },
	      _react2.default.createElement(Logo, { id: 'logo', src: _firstPrincipleLogo2.default, alt: 'First Principle logo' })
	    ),
	    _react2.default.createElement(VerticalLinksComponent, null)
	  );
	};
	
	exports.default = Sidebar;
	module.exports = exports['default'];

/***/ }),

/***/ 371:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 0 ', ' 0;\n  margin: 2.499399183rem 0 0;\n  visibility: ', '\n  @media ', ' {\n    padding: 0 10% 0 ', ';\n    margin: 2.499399183rem 0 0 40%;\n    display: block;\n  }\n'], ['\n  padding: 0 ', ' 0;\n  margin: 2.499399183rem 0 0;\n  visibility: ', '\n  @media ', ' {\n    padding: 0 10% 0 ', ';\n    margin: 2.499399183rem 0 0 40%;\n    display: block;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-size: ', ';\n  padding: ', ';\n  color: ', ';\n  margin-top: 0.889209325rem;\n  @media ', ' {\n    margin-left: 40%;\n  }\n'], ['\n  font-size: ', ';\n  padding: ', ';\n  color: ', ';\n  margin-top: 0.889209325rem;\n  @media ', ' {\n    margin-left: 40%;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(246);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(45);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _config = __webpack_require__(21);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _media = __webpack_require__(34);
	
	var _Sidebar = __webpack_require__(269);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _FadeIn = __webpack_require__(29);
	
	var _FadeIn2 = _interopRequireDefault(_FadeIn);
	
	var _NavLink = __webpack_require__(53);
	
	var _NavLink2 = _interopRequireDefault(_NavLink);
	
	var _MobileHeader = __webpack_require__(267);
	
	var _MobileHeader2 = _interopRequireDefault(_MobileHeader);
	
	__webpack_require__(371);
	
	var _favicon = __webpack_require__(646);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Main = _styledComponents2.default.main(_templateObject, _config2.default.padding, function (props) {
	  return props.hide ? 'hidden' : 'visible';
	}, _media.device.mobile, _config2.default.padding);
	
	var Footer = _styledComponents2.default.footer(_templateObject2, _config2.default.finePrintFontSize, _config2.default.padding, _config2.default.navLinkColor, _media.device.mobile);
	
	var TemplateWrapper = function (_React$Component) {
	  _inherits(TemplateWrapper, _React$Component);
	
	  function TemplateWrapper(props) {
	    _classCallCheck(this, TemplateWrapper);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.componentWillUpdate = function (prevProps, prevState) {
	      if (_this.props.location.pathname !== prevProps.location.pathname) {
	        _this.setState(function (prevState, props) {
	          return {
	            loading: true
	          };
	        });
	      }
	    };
	
	    _this.componentDidUpdate = function (prevProps, prevState) {
	      if (_this.props.location.pathname !== prevProps.location.pathname) {
	        _this.setState(function (prevState, props) {
	          return {
	            loading: false
	          };
	        });
	      }
	    };
	
	    _this.shouldComponentUpdate = function (nextProps, nextState) {
	      if (_this.props.location.pathname !== nextProps.location.pathname) {
	        return true;
	      }
	      return false;
	    };
	
	    _this.state = {
	      loading: false
	    };
	    return _this;
	  }
	
	  TemplateWrapper.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        { title: _config2.default.title },
	        _react2.default.createElement('html', { lang: 'en' }),
	        _react2.default.createElement('meta', { property: 'og:title', content: _config2.default.title }),
	        _react2.default.createElement('meta', { property: 'og:image', content: 'https://firstprinciple.team/first-principle-logo.jpg' }),
	        _react2.default.createElement('link', { rel: 'shortcut icon', type: 'image/png', href: _favicon2.default }),
	        _react2.default.createElement('script', { type: 'text/javascript', id: 'hs-script-loader', async: true, defer: true, src: '//js.hs-scripts.com/4426351.js' })
	      ),
	      _react2.default.createElement(_MobileHeader2.default, null),
	      _react2.default.createElement(_Sidebar2.default, null),
	      _react2.default.createElement(
	        Main,
	        { id: 'main', hide: this.state.loading },
	        this.props.children()
	      ),
	      _react2.default.createElement(
	        _FadeIn2.default,
	        null,
	        _react2.default.createElement(
	          Footer,
	          { id: 'footer' },
	          'All content \xA9 First Principle'
	        )
	      )
	    );
	  };
	
	  return TemplateWrapper;
	}(_react2.default.Component);
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-7ebb62e67f62c987813d.js